
const phone10DigitsView = {
	read: p => p && (String(p)).replace(/\D+/g, '').slice(-10),
	write: p => p && ('+7' + p),
};
const phone10DigitsViewExtend = { view: { phone10Digits: phone10DigitsView } };

module.exports = {
	phone10DigitsView,
	phone10DigitsViewExtend,
};
